import axios from 'axios';

const TOKEN_KEY = 'polyrion_auth_token';

const baseURL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:9000/api';

export const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return config;
  }
  return {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    },
  };
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 503 && error.response?.data?.maintenance) {
      window.dispatchEvent(new CustomEvent('polyrion:maintenance'));
    }
    return Promise.reject(error);
  },
);

export { TOKEN_KEY };
